// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TestBlockV2_tabs__3m-aP","pageScroll":"TestBlockV2_pageScroll__1BFQS"};